<template>
	<v-container style="position: absolute; height: 100%; width: 100%;">
		<Keypress key-event="keyup" :key-code="65" @success="chama" />
		<a-scene vr-mode-ui="enabled: true">
			<a-sky :src="imgURL" rotation="0 -130 0" color="#ECECEC"></a-sky>
			<!--
			<a-plane
				class="clickable"
				position="0 1 -3.3"
				rotation="0 5 0"
				material="opacity: 0.3; transparent: true"
				color="#000000"
				:scale="getTamanhoPlane"
				:event-set__enterA="getTamanhoPlaneEnter"
				:event-set__leaveA="getTamanhoPlaneLeave"
				event-set__enterB="_event: mouseenter; _target: #tituloid; visible: false"
				event-set__leaveB="_event: mouseleave; _target: #tituloid; visible: true"
				event-set__enter="_event: mouseenter; _target: #textoid; visible: true"
				event-set__leave="_event: mouseleave; _target: #textoid; visible: false"
			></a-plane>
			<a-text id="textoid" font="roboto" visible="false" :value="getInfo" width="3" :position="getPosicaoInfo" rotation="0 5 0"></a-text>
			<a-text id="tituloid" font="roboto" visible="true" value="Dados" width="3" :position="getPosicaoInfo" rotation="0 5 0"></a-text>
			-->

			<a-plane class="clickable" position="0 -0.1 -3.3" rotation="0 5 0" material="opacity: 0.3; transparent: true" color="#000000" :scale="getTamanhoPlane" :event-set__enterA="getTamanhoPlaneEnter" :event-set__leaveA="getTamanhoPlaneLeave"></a-plane>
			<a-text id="textoid" font="roboto" visible="true" :value="getInfo" width="2.5" :position="getPosicaoInfo" rotation="0 5 0"></a-text>

			<a-entity camera look-controls position="0 1.6 0">
				<a-entity cursor="fuse: true" material="color: black" geometry="primitive: ring; radiusInner: 0.02; radiusOuter: 0.03" position="0 0 -3" raycaster="far: 20; interval: 100; objects: .clickable"></a-entity>
			</a-entity>
		</a-scene>
	</v-container>
</template>

<script>
import "aframe";
import "aframe-event-set-component";
import { mapActions, mapState } from "vuex";
export default {
	components: {
		Keypress: () => import("vue-keypress"),
	},
	name: "VR",
	data() {
		return {
			imgURL: "",
			info: "",
			id: this.$route.query.id,
		};
	},
	async created() {
		await this.getCenarioByIdOpenSoils(this.id);
		await this.getCenario(this.id);

		this.imgURL = this.cenarioVR.imagem;
		this.info = this.getDescricaoCompleta();
	},
	mounted() {},
	methods: {
		...mapActions(["getCenarioByIdOpenSoils"]),
		...mapActions(["getCenario"]),

		chama() {
			//todo
		},

		getDescricaoCompleta() {
			let desc = "";
			if (this.cenario.descricao.sibics_atual) desc += "Classificação: " + this.cenario.descricao.sibics_atual + "\n";
			if (this.cenario.descricao.localizacao) desc += "Localização: " + this.cenario.descricao.localizacao + "\n";
			if (this.cenario.descricao.valor_pedregosidade) desc += "Pedregosidade: " + this.cenario.descricao.valor_pedregosidade + "\n";
			if (this.cenario.descricao.valor_rochosidade) desc += "Rochosidade: " + this.cenario.descricao.valor_rochosidade + "\n";
			if (this.cenario.descricao.valor_drenagem) desc += "Drenagem: " + this.cenario.descricao.valor_drenagem + "\n";
			if (this.cenario.descricao.vegetacao_primaria) desc += "Vegetação Primária: " + this.cenario.descricao.vegetacao_primaria + "\n";
			if (this.cenario.descricao.situacao_declive) desc += "Situação Declive:" + this.cenario.descricao.situacao_declive + "\n";
			if (this.cenario.descricao.formacao_geologica) desc += "Formação Geológica: " + this.cenario.descricao.formacao_geologica + "\n";
			if (this.cenario.descricao.litologia) desc += "Litologia: " + this.cenario.descricao.litologia + "\n";
			if (this.cenario.descricao.material_originario) desc += "Material Originário: " + this.cenario.descricao.material_originario + "\n";
			if (this.cenario.descricao.relevo.relevo_local) desc += "Relevo Local: " + this.cenario.descricao.relevo.relevo_local + "\n";
			if (this.cenario.descricao.relevo.relevo_regional) desc += "Relevo Regional: " + this.cenario.descricao.relevo.relevo_regional + "\n";
			if (this.cenario.descricao.erosoes[0].forma_erosao) desc += "Forma Erosão: " + this.cenario.descricao.erosoes[0].forma_erosao + "\n";
			if (this.cenario.descricao.uso_atual) desc += "Uso Atual: " + this.cenario.descricao.uso_atual + "\n";
			if (this.cenario.descricao.descrito_coletado) desc += "Descrito por: " + this.cenario.descricao.descrito_coletado + "\n";
			return desc;
		},
	},
	computed: {
		...mapState(["cenarioVR"]),
		...mapState(["cenario"]),

		getInfo() {
			var info = this.info;
			info = info.replaceAll("ç", "c");
			info = info.replaceAll("á", "a");
			info = info.replaceAll("ã", "a");
			info = info.replaceAll("à", "a");
			info = info.replaceAll("é", "e");
			info = info.replaceAll("ê", "e");
			info = info.replaceAll("í", "i");
			info = info.replaceAll("ó", "o");
			info = info.replaceAll("õ", "o");
			info = info.replaceAll("ú", "U");

			info = info.replaceAll("Ç", "C");
			info = info.replaceAll("Á", "A");
			info = info.replaceAll("Ã", "A");
			info = info.replaceAll("À", "A");
			info = info.replaceAll("É", "E");
			info = info.replaceAll("Ê", "E");
			info = info.replaceAll("Í", "I");
			info = info.replaceAll("Ó", "O");
			info = info.replaceAll("Õ", "O");
			info = info.replaceAll("Ú", "U");

			return info;
		},
		getTamanhoPlaneX() {
			//Largura do Painel
			let tamX = 3;
			if (this.info.length < 39) {
				tamX = this.info.length / 11;
			}
			return tamX;
		},
		getTamanhoPlaneY() {
			//Altura do Painel
			let linhas = -1;
			let tamY = 1.6;
			let vetor = this.info.split("\n");
			for (var i = 0; i < vetor.length; i++) {
				if (vetor[i].length > 40) {
					linhas = linhas + Math.floor(vetor[i].length / 40);
				}
				linhas = linhas + 1;
			}
			tamY = linhas * 0.17;
			return tamY;
		},
		getTamanhoPlane() {
			let tam = this.getTamanhoPlaneX + " " + this.getTamanhoPlaneY + " 1";
			return tam;
		},
		getTamanhoPlaneEnter() {
			let tamX = this.getTamanhoPlaneX + 0.3;
			let tamY = this.getTamanhoPlaneY + 0.3;
			return "_event: mouseenter; color: #D0D0D0; scale:" + tamX + " " + tamY + " 1";
		},
		getTamanhoPlaneLeave() {
			return "_event: mouseleave; color: #000000; scale:" + this.getTamanhoPlane;
		},
		getPosicaoInfo() {
			let posX = -1.2;
			/*
			if (this.info.length < 39) {
				posX = 0.1 - this.info.length / 11 / 2;
			}
			*/
			let posY = 0;
			/*
			let linhas = -1;
			let vetor = this.info.split("\n");
			for (var i = 0; i < vetor.length; i++) {
				if (vetor[i].length > 40) {
					linhas = linhas + Math.floor(vetor[i].length/40);
				}
				linhas = linhas + 1;
			}
			posY = linhas * 0;
			*/
			let pos = posX + " " + posY + " -3";
			return pos;
		},
	},
};
</script>

<style scoped>
.fullscreen {
	height: 100vh;
	position: relative;
}
</style>
